import LabAppointment from './AppointmentTab';
export default {
  'labAppointment': {
    screen: LabAppointment,
  },
};
